import { ListingCard } from "@/components/ListingCard";

// Horizontal ads row used on the home page (same look as "عروض وخصومات").
export function HomeRow({ title, ads, ar, testid, action }) {
  if (!ads.length) return null;
  return (
    <section className="mb-8 lg:mb-12" data-testid={testid}>
      <div dir={ar ? "rtl" : "ltr"} className="flex items-center justify-between mb-4 lg:mb-5">
        <h3 className={`font-headline ${ar ? "text-xl text-right" : "text-lg text-left"} font-extrabold text-slate-900 lg:text-2xl`} data-testid={`${testid}-title`}>{title}</h3>
        {action}
      </div>
      <div className="flex gap-4 lg:gap-6 overflow-x-auto no-scrollbar pb-1" data-testid={`${testid}-list`}>
        {ads.map((l) => <div key={l.id} className="w-44 sm:w-52 lg:w-[calc((100%-4.5rem)/4)] xl:w-[calc((100%-6rem)/5)] shrink-0"><ListingCard listing={l} big={ar} /></div>)}
      </div>
    </section>
  );
}
